import { render, staticRenderFns } from "./RutasPantalla.vue?vue&type=template&id=0a1e5223&"
import script from "./RutasPantalla.vue?vue&type=script&lang=ts&"
export * from "./RutasPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports